import React from "react";

const PageShell = ({ kicker, title, accent, intro, children, testid }) => (
    <div data-testid={testid}>
        <section className="px-4 md:px-8 py-10 md:py-16 border-b-4 border-ink">
            {kicker && (
                <span className="font-mono-ui text-xs uppercase tracking-[0.3em] text-hazard">
                    {kicker}
                </span>
            )}
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl uppercase leading-[0.85] mt-2">
                {title}
                {accent && (
                    <>
                        <br />
                        <span className="text-hazard">{accent}</span>
                    </>
                )}
            </h1>
            {intro && (
                <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-foreground/80">
                    {intro}
                </p>
            )}
        </section>
        {children}
    </div>
);

export default PageShell;
